import React from 'react'

import { Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import TextField from 'modules/core/components/TextField'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import type Company from 'modules/core/store/models/Company'

import CompanyGeneralForm from 'modules/settings/lib/forms/General'

interface Props {
  company: Company
}

export const PrivacyPolicy = observer(({ company }: Props) => {
  const form = React.useRef(new CompanyGeneralForm(company.toJS())).current
  const [publicEmail, setPublicEmail] = React.useState(form.get('public_email').value)

  const handleOnChage = (email: string) => {
    form.setValues({ public_email: email })
    setPublicEmail(email)
  }

  const onSubmit = async () => {
    if (!form.isDirty) return

    const data = form.data()
    const email = form.get('public_email')

    if (email.isDirty) {
      form.setValues(data)
      await asyncAction(() => form.save(company), {
        errorFlash: false,
      })
    }
  }

  return (
    <Section.Form
      illustration="lock-user"
      title={i18n.t('company_settings.general.company_page.options.privacy_policy.title')}
      description={i18n.t(
        'company_settings.general.company_page.options.privacy_policy.description'
      )}
      onSubmit={onSubmit}
      isDirty={form.isDirty}
      submitLabel={i18n.t('common.submit')}
    >
      <TextField
        type="email"
        label={i18n.t('company_settings.general.company_page.options.privacy_policy.email_label')}
        value={publicEmail}
        onChange={(email) => handleOnChage(email)}
        secondaryLabel={
          <InformationTooltip
            information={i18n.t(
              'company_settings.general.company_page.options.privacy_policy.email_tooltip'
            )}
            icon="question"
          />
        }
        mandatory
      />
    </Section.Form>
  )
})
